export const FILING_DISCOUNT = 'Filing Discount';
export const TAX_GUIDE = 'Tax Guide';
export const DEDUCTION_GUIDE = 'Deduction Guide';
export const SUPPORT = 'Support';
export const STRIDE_TAX = 'Stride Tax';
export const TRACKING_PREFIX = 'Tax: Host: Reward';
